import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OutsideClickDirective } from '../../outside-click.directive';

@Component({
    selector: 'app-user-info-modal',
    imports: [OutsideClickDirective],
    templateUrl: './user-info-modal.component.html',
    styleUrl: './user-info-modal.component.scss'
})
export class UserInfoModalComponent {
    @Input() message!: string;
    @Output() onCancel:EventEmitter<any>= new EventEmitter<any>();
    
    ngOnInit() {}
    clickOutside(isOut: any) {      
      if (!isOut) {
        this.onCancel.emit();
      }
    }  
}


